module.exports = __webpack_public_path__ + "static/media/gs_large.851a40c2.jpg";